export default __webpack_public_path__ + "static/media/Snd_LowerVSlideup.14989654.mp3";